export default "__VITE_ASSET__C_O45EDz__"